import React from 'react'
import { t } from 'i18next'
import { Input } from 'antd'

export default function OwnerFilter ({ filter, onChangeFilter }) {
  const onChange = (hash) => {
    onChangeFilter({ ...filter, ...hash })
  }
  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <Input
        style={{ width: '150px' }}
        onChange={(e) => { onChange({ name: e.target.value }) }} placeholder={t('Admin.AppointmentFilter.name')}
        value={filter.name}
      />
    </div>
  )
}
